/**
 * units (#441) — the conversion factors, stated once.
 *
 * These were each defined two or three times across the tracking code
 * (`useContextualNotams`, `SimulatedPositionProvider`). Two copies of a
 * constant are two chances to typo one of them, and a wrong factor here
 * shows up as an altitude or a ground speed that is quietly off.
 */
export const FEET_PER_METER = 3.28084;

/** Knots to metres per second. Exact: a nautical mile is 1852 m. */
export const METERS_PER_SECOND_PER_KNOT = 1852 / 3600;

/** Metres per second to knots. */
export const KT_PER_MS = 1 / METERS_PER_SECOND_PER_KNOT;
